export const environment = {
  production: true,
  apiUrl: 'https://app.licord.it',
  redirectUrl: 'https://app.licord.it',
  logLevel: 'error'
};
